/**
 * POST payload for endpoint /api/secrets/bulkpermissionschange
 */
export class UpdateSecretPermissionsRequest {

    constructor(secretIds: number[],
        owners: string[],
        viewers: string[],
        revoke: string[],
        usingAdminRole: boolean,
        adminJustification: string
    ) {
        this.secretIds = secretIds;
        this.owners = owners;
        this.viewers = viewers;
        this.revoke = revoke;
        this.usingAdminRole = usingAdminRole;
        this.adminJustification = adminJustification;
    }

    secretIds: number[] = [];
    owners: string[] = [];
    viewers: string[] = [];
    revoke: string[] = [];
    
    usingAdminRole: boolean = false;
    adminJustification: string = "";
}